import { useState } from 'react';
import { Save, X } from 'lucide-react';
import { LoadingSpinner } from '../ui/LoadingSpinner';
import type { Week, WeekFormData } from '../../types';

interface WeekFormProps {
  planId: string;
  nextWeekNumber: number;
  initialData?: Week;
  onSubmit: (data: WeekFormData) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function WeekForm({ planId, nextWeekNumber, initialData, onSubmit, onCancel, isLoading }: WeekFormProps) {
  const [formData, setFormData] = useState<WeekFormData>({
    weekNumber: initialData?.weekNumber || nextWeekNumber,
    name: initialData?.name || '',
    notes: initialData?.notes || '',
    planId: planId,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'number' ? parseInt(value) : value,
    }));
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="weekNumber" className="label">Número de Semana *</label>
          <input
            type="number"
            id="weekNumber"
            name="weekNumber"
            value={formData.weekNumber}
            onChange={handleChange}
            required
            min={1}
            className="input"
          />
        </div>
        <div>
          <label htmlFor="name" className="label">Nombre (opcional)</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="input"
            placeholder="Ej: Semana de Adaptación"
          />
        </div>
      </div>

      <div>
        <label htmlFor="notes" className="label">Notas</label>
        <textarea
          id="notes"
          name="notes"
          value={formData.notes}
          onChange={handleChange}
          rows={3}
          className="input resize-none"
          placeholder="Objetivos de la semana, indicaciones..."
        />
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t border-dark-700">
        <button type="button" onClick={onCancel} className="btn-secondary">
          <X className="w-4 h-4" />
          Cancelar
        </button>
        <button type="submit" disabled={isLoading} className="btn-primary">
          {isLoading ? (
            <LoadingSpinner size="sm" />
          ) : (
            <>
              <Save className="w-4 h-4" />
              {initialData ? 'Guardar' : 'Crear Semana'}
            </>
          )}
        </button>
      </div>
    </form>
  );
}

